const GetLinkFromCta = (cta) => {
    const { externalLink, internalLink, action, openInNewTab, trackingName } = cta;
    const isInternal = !!internalLink.fields.handle.length;
    const isExternal = !!externalLink;
    if (isInternal) {
        return {
            type: 'Internal',
            to: `/${internalLink.fields.handle}`,
            openInNewTab,
        };
    }
    else if (isExternal) {
        return { type: 'External', to: externalLink, openInNewTab };
    }
    else if (!!action) {
        if (action === 'clientApp') {
            return {
                type: 'Action',
                to: `${process.env.CLIENT_APP_URL}/signup?content_cta=${trackingName}`,
                openInNewTab,
            };
        }
        else {
            return {
                type: 'Action',
                to: action,
            };
        }
    }
    else {
        return {
            type: 'None',
            to: '',
        };
    }
};
export default GetLinkFromCta;
